export function filterUndefined(object) {
    return Object.entries(object).reduce(function (accumulator, [key, value]) {
        if (value !== undefined) {
            accumulator[key] = value
        }

        return accumulator
    }, {})
}
